import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-a66572ee"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dashboards-container" }
const _hoisted_2 = {
  key: 0,
  class: "form-block m-b-12"
}
const _hoisted_3 = { class: "flex some-inputs" }
const _hoisted_4 = { class: "flex flex-col m-r-20 input-container" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "small-label" }, "Воркбук", -1))
const _hoisted_6 = { class: "flex flex-col input-container" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "small-label" }, "Дашборд", -1))
const _hoisted_8 = {
  key: 0,
  class: "flex flex-row m-b-2 m-l-12 flex-end"
}
const _hoisted_9 = ["title"]
const _hoisted_10 = {
  key: 0,
  class: "flex flex-col m-t-12"
}
const _hoisted_11 = { class: "m-0" }
const _hoisted_12 = { id: "dashboard-container" }
const _hoisted_13 = {
  key: 0,
  class: "form-block"
}
const _hoisted_14 = ["src", "width", "height"]
const _hoisted_15 = {
  key: 0,
  class: "overlay"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-times" }, null, -1))
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = ["src"]

import { ref, watch, onMounted } from "vue";
import { useRouter, useRoute } from "vue-router";
import Accordion from "primevue/accordion";
import AccordionTab from "primevue/accordiontab";

import { useDashbordsStore } from "@/store/analytics/dasboards";
import { Dashboard } from "@/store/analytics/dasboards";
import { isNumeric } from "@/services/utils/Strings";

import CatalogDataSingleInput from "@/widgets/forms/CatalogDataSingleInput.vue";
import Dropdown from "primevue/dropdown";
import Button from "primevue/button";
import HandlerAccessDenied from "@/shared/base/HandlerAccessDenied.vue";
import { useSidebarStore } from "@/store/sidebar/sidebar";


export default /*#__PURE__*/_defineComponent({
  __name: 'DashboardsViewForm',
  props: [
  "store",
  "type",
  "hideExpandButton",
  "defaultWorkbook",
  "defaultDashboard",
],
  emits: ["dashboardSelected"],
  setup(__props, { expose: __expose, emit: __emit }) {

const props = __props;
const emit = __emit;

const workbook = ref({
  workbook: null as number | null,
  dashboard: null as Dashboard | null,
});

const isDenied = ref(false);

const isFullPageDashboard = ref(false);
const dashboards = ref([] as Dashboard[]);
const router = useRouter();
const route = useRoute();
const store = useDashbordsStore();
const sidebarStore = useSidebarStore();
const isLoadingData = ref(false);
const token = ref("");
const rectSizes = ref({
  width: 0,
  height: 0,
});

watch(
  () => workbook.value.workbook,
  () => {
    setDashboards();
  }
);

watch(
  () => sidebarStore.isOpen,
  () => setSizes()
);

watch(
  () => workbook.value.dashboard,
  (newValue) => {
    // Уведомляем родительский компонент о выборе дашборда
    emit("dashboardSelected", newValue != null);

    if (newValue && workbook.value.workbook) {
      isDenied.value = false;
      setTimeout(() => {
        setSizes();
      }, 100);
      isLoadingData.value = true;
      store
        .getToken(workbook.value.workbook, newValue.id)
        .then((tokenData) => {
          token.value = tokenData;
          isLoadingData.value = false;
        })
        .catch((err) => {
          if (err.response && err.response.status == 403) {
            isDenied.value = true;
          }
        });
      if (!props.defaultWorkbook || !props.defaultDashboard) {
        router.push({
          name: route.name,
          query: { dashboard: newValue.id, workbook: workbook.value.workbook },
        });
      }
    }
  }
);

// Функция для загрузки и установки дашборда
const loadAndSetDashboard = (
  workbookId: number,
  dashboardId: number,
  isPreset = false
) => {
  props.store.getItems("", [workbookId], true, true).then(() => {
    const foundItem = props.store.itemList.find(
      (item: any) => item.id === workbookId
    );

    if (!foundItem) {
      if (!isPreset) {
        router.push({ name: route.name });
      }
      return;
    }

    store.getWorkbook(workbookId).then((data) => {
      if (data) {
        workbook.value.workbook = workbookId;
        const foundDashboard = data.dashboards.find(
          (item: any) => item.id === dashboardId
        );
        if (foundDashboard) {
          workbook.value.dashboard = foundDashboard;
          if (isPreset) {
            emit("dashboardSelected", true);
          }
        }
      }
    });
  });
};

// Для установки сразу в инпуты единственного доступного дашборда
const loadSingleAvailableDashboard = () => {
  props.store.getItems("", [], true).then(() => {
    if (props.store.itemList.length == 1) {
      workbook.value.workbook = props.store.itemList[0].id;
      if (props.store.itemList[0].dashboards.length == 1) {
        workbook.value.dashboard = props.store.itemList[0].dashboards[0];
      }
    }
  });
};

onMounted(() => {
  // Если переданы предустановленные значения, используем их
  if (props.defaultWorkbook && props.defaultDashboard) {
    loadAndSetDashboard(props.defaultWorkbook, props.defaultDashboard, true);
    return;
  }

  // Иначе смотрим query
  const workbookQ = route.query.workbook;

  if (isNumeric(workbookQ)) {
    const workbookId = parseInt(workbookQ);
    const dashboardQ = route.query.dashboard;

    if (dashboardQ && isNumeric(dashboardQ)) {
      loadAndSetDashboard(workbookId, parseInt(dashboardQ));
    } else {
      // Ставим в инпут только воркбук без дашборда
      props.store.getItems("", [workbookId], true, true).then(() => {
        const foundItem = props.store.itemList.find(
          (item: any) => item.id === workbookId
        );
        if (!foundItem) {
          router.push({ name: route.name });
        }
      });
    }
  } else {
    loadSingleAvailableDashboard();
  }
});

const setDashboards = () => {
  if (workbook.value.workbook) {
    const foundItem = props.store.itemList.find(
      (item: any) => item.id === workbook.value.workbook
    );
    if (foundItem) {
      dashboards.value = foundItem.dashboards;
      return;
    }
  }
  dashboards.value = [];
};

const getToken = () => {
  return `https://datalens.ru/embeds/dash#dl_embed_token=${token.value}`;
};

const calcSizes = () => {
  // Получаем элемент, расстояние которого хотим вычислить
  const element = document.getElementById("dashboard-container");

  if (element) {
    const rect = element.getBoundingClientRect();
    // Получаем размеры окна просмотра
    const viewportWidth = window.innerWidth;
    const viewportHeight = window.innerHeight;
    const distanceToRight = viewportWidth - rect.left;
    const distanceToBottom = viewportHeight - rect.top;

    return {
      right: distanceToRight - 35,
      bottom: distanceToBottom - 45,
    };
  }
};

const setSizes = () => {
  const sizes = calcSizes();
  if (sizes) {
    rectSizes.value.height = sizes.bottom;
    rectSizes.value.width = sizes.right;
  }
};

const tabClick = () => {
  clearTimeout(resizeTimeout);
  resizeTimeout = setTimeout(() => {
    setSizes();
  }, 300);
};

const setFullPageDashbordSize = () => {
  isFullPageDashboard.value = true;
};

// Экспортируем функцию для вызова извне
__expose({
  expandDashboard: () => {
    isFullPageDashboard.value = true;
  },
});

let resizeTimeout: number;
window.addEventListener("resize", function () {
  clearTimeout(resizeTimeout);
  resizeTimeout = setTimeout(() => {
    setSizes();
  }, 1);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (!props.defaultWorkbook || !props.defaultDashboard)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _hoisted_5,
                _createVNode(CatalogDataSingleInput, {
                  useIdOnly: true,
                  selectType: props.type,
                  isSegmentSetted: false,
                  modelValue: workbook.value.workbook,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = 
              ($event) => {
                workbook.value.dashboard = null;
                _unref(router).push({
                  name: _unref(route).name,
                });
                workbook.value.workbook = $event;
              }
            )
                }, null, 8, ["selectType", "modelValue"])
              ]),
              _createElementVNode("div", _hoisted_6, [
                _hoisted_7,
                _createVNode(_unref(Dropdown), {
                  modelValue: workbook.value.dashboard,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((workbook.value.dashboard) = $event)),
                  optionLabel: "name",
                  options: dashboards.value,
                  disabled: workbook.value.workbook == null,
                  placeholder: "Выберите значение",
                  filter: ""
                }, null, 8, ["modelValue", "options", "disabled"])
              ]),
              (!props.hideExpandButton)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _createElementVNode("div", {
                      title: 
              workbook.value.dashboard == null
                ? 'Сначала выберите дашборд'
                : 'Развернуть дашборд на весь экран'
            
                    }, [
                      _createVNode(_unref(Button), {
                        disabled: workbook.value.dashboard == null,
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (isFullPageDashboard.value = true)),
                        icon: "pi pi-window-maximize",
                        label: "Во весь экран",
                        class: "expand-button",
                        pt: {
                root: {
                  style: 'min-width: 150px; white-space: nowrap; height: 32px',
                },
              }
                      }, null, 8, ["disabled"])
                    ], 8, _hoisted_9)
                  ]))
                : _createCommentVNode("", true)
            ]),
            (
          workbook.value.dashboard != null &&
          workbook.value.dashboard.description &&
          workbook.value.dashboard.description.length > 0
        )
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  _createVNode(_unref(Accordion), {
                    class: "accord-my",
                    onTabClick: tabClick
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(AccordionTab), { header: "Описание дашборда" }, {
                        default: _withCtx(() => [
                          _createElementVNode("p", _hoisted_11, _toDisplayString(workbook.value.dashboard.description), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      _createVNode(HandlerAccessDenied, { "is-denied": isDenied.value }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_12, [
            (
            token.value.length > 0 && workbook.value.dashboard != null && !isLoadingData.value
          )
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                  _createElementVNode("iframe", {
                    src: getToken(),
                    frameborder: "0",
                    width: rectSizes.value.width,
                    height: rectSizes.value.height
                  }, null, 8, _hoisted_14)
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      }, 8, ["is-denied"])
    ]),
    (isFullPageDashboard.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
          _createElementVNode("button", {
            class: "close-button",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (isFullPageDashboard.value = false)),
            title: "Закрыть"
          }, _hoisted_17),
          _createElementVNode("iframe", {
            class: "overlay-iframe",
            src: getToken(),
            frameborder: "0"
          }, null, 8, _hoisted_18)
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})